module.exports = "<p>\r\n  blank-layout works!\r\n</p>\r\n"